import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [{
      // 登录界面
      path: '/login',
      name: 'Login',
      component: () => import("@/views/login")
    },
    // 数字大屏
    {
      path: '/digital/index',
      name: 'DigitalIndex',
      component: () =>import("@/views/digital/index.vue")
    },
    {
      path: '/',
      component: ()=>import("@/layout/default"),
      children: [
        // 首页（概览）：组件本身已落在 views/index/index.vue
        // name 'Index' 是 login.vue 登录后的跳转目标，不可删（删了会按名匹配失败 → 整页白屏）
        // 注：sng-service 的代码生成模板 Router.tem:23 也引用 @/views/index/index，改名后已自洽
        {
          path: '',
          name: 'Index',
          component: () => import("@/views/index/index")
        },
        // 旧路径 /statistics 保留为重定向，兼容已存在的书签与直链
        // name 'IndexStatistics' 必须留着：后端 permission.front_router 存量数据里「概览」仍是这个旧名，
        // 删掉后 default.vue 的守卫会 resolve 不到（matched=[]）→ 点侧边栏「概览」弹「菜单未配置前端路由」。
        {
          path: '/statistics',
          name: 'IndexStatistics',
          redirect: { name: 'Index' }
        },
        // 课程管理
        {
          path: '/course/index',
          name: 'CourseIndex',
          component: () => import("@/views/course/index"),
          meta: {
            keepAlive: true
          }
        },
        // 发布课程
        {
          path: '/course/create',
          name: 'CourseCreate',
          component: () => import("@/views/course/create")
        },
        // 复制课程
        {
          path: '/course/duplicate',
          name: 'CourseDuplicate',
          component: () => import("@/views/course/duplicate")
        },
        // 修改登录密码
        {
          path: '/admin/editpassword',
          name: 'AdminEditPassword',
          component: () => import("@/views/admin/editpassword")
        },
        // 用户列表（管理员列表）
        {
          path: '/admin/index',
          name: 'AdminIndex',
          component: () => import("@/views/admin/index")
        },
        // 教师管理
        {
          path: '/teacher/index',
          name: 'TeacherIndex',
          component: () => import("@/views/teacher/index")
        },
        // 场地管理
        {
          path: '/school/site/index',
          name: 'SchoolSiteIndex',
          component: () => import("@/views/schoolSite/index")
        },
        // 楼栋管理
        {
          path: '/school/building/index',
          name: 'SchoolBuildingIndex',
          component: () => import("@/views/schoolBuilding/index")
        },
        // 学校基本信息
        {
          path: '/config/school',
          name: 'ConfigSchool',
          component: () => import("@/views/config/school")
        },
        // 学员管理
        {
          path: '/student/index',
          name: 'StudentIndex',
          component: () => import("@/views/student/index")
        },

        // 部门管理
        {
          path: '/department/index',
          name: 'DepartmentIndex',
          component: () => import("@/views/department/index")
        },
        // 角色管理
        {
          path: '/role/index',
          name: 'RoleIndex',
          component: () => import("@/views/role/index")
        },
        // 教师申请审核
        {
          path: '/teacher/apply/index',
          name: 'TeacherApplyIndex',
          component: () => import("@/views/teacherApply/index")
        },
        // 上课时间安排
        {
          path: '/school/time/rule/index',
          name: 'SchoolTimeRuleIndex',
          component: () => import("@/views/schoolTimeRule/index")
        },
        // 订单管理
        {
          path: '/student/order/course',
          name: 'StudentOrderCourse',
          component: () => import("@/views/studentOrder/courseOrder.vue")
        },
        // 退费管理
        {
          path: '/student/order/refund',
          name: 'StudentOrderRefund',
          component: () => import("@/views/studentOrder/refundApply.vue")
        },
        // 物料订单
        {
          path: '/student/order/material',
          name: 'StudentOrderMaterial',
          component: () => import("@/views/studentOrder/material.vue")
        },
        // 旧路由兼容（重定向到订单管理）
        {
          path: '/student/order/index',
          redirect: '/student/order/course'
        },
        // 课程班级
        {
          path: '/course/class/index',
          name: 'CourseClassIndex',
          component: () => import("@/views/courseClass/index")
        },
        // 岗位信息
        {
          path: '/school/position/index',
          name: 'SchoolPositionIndex',
          component: () => import("@/views/schoolPosition/index")
        },
        // 邀请注册设置
        {
          path: '/config/register',
          name: 'ConfigRegister',
          component: () => import("@/views/config/register")
        },
        // 学员字段配置
        {
          path: '/config/studentField',
          name: 'ConfigStudentField',
          component: () => import("@/views/config/studentField")
        },
        {
          path: '/course/class/class',
          name: 'CourseClassClass',
          component: () => import("@/views/courseClass/class")
        },
        {
          path: '/course/class/detail',
          name: 'CourseClassDetail',
          component: () =>import("@/views/courseClass/detail")
        },
        // 创建班级
        {
          path: '/course/class/create',
          name: 'CourseClassCreate',
          component: () => import("@/views/courseClass/createClass")
        },
        {
          path: '/course/class/edit',
          name: 'CourseClassEdit',
          component: () => import("@/views/courseClass/editClass")
        },
        // 排课中心（统一排课入口）
        {
          path: '/course/class/scheduleCenter',
          name: 'ScheduleCenter',
          meta: { title: '排课中心' },
          component: () => import("@/views/scheduleCenter/scheduleCenter")
        },
        // 普通课表（表格视图，无日历）
        {
          path: '/course/class/regularTimetable',
          name: 'RegularTimetable',
          meta: { title: '普通课表' },
          component: () => import("@/views/scheduleCenter/regularTimetable")
        },
        // 创建招生（从课程班级进入）
        {
          path: '/course/class/createEnroll',
          name: 'ClassEnrollCreateByClass',
          component: () => import("@/views/enroll/createEnroll"),
          meta: {
            keepAlive: false
          }
        },
        // 招生信息
        {
          path: '/course/enroll/index',
          name: 'ClassEnrollIndex',
          component: () =>import("@/views/enroll/index"),
          meta: {
            keepAlive: true
          }
        },
        // 审核列表
        {
          path: '/course/enroll/approveEnroll',
          name: 'ClassEnrollApprove',
          component: ()=> import("@/views/enroll/approveEnroll"),
          meta: {
            keepAlive: true
          }},
        // 创建招生
        {
          path: '/course/enroll/createEnroll',
          name: 'ClassEnrollCreate',
          component: () => import("@/views/enroll/createEnroll"),
          meta: {
            keepAlive: false
          }
        },

        {
          path: '/course/enroll/detailEnroll',
          name: 'EnrollDetail',
          component: () => import("@/views/enroll/detailEnroll")
        },
        // 招生学员列表
        {
          path: '/course/enroll/studentsEnroll',
          name: 'EnrollStudents',
          component: () => import("@/views/enroll/enrollStudents")
        },

        // 学年
        {
          path: '/school/year/index',
          name: 'SchoolYearIndex',
          component: () =>import("@/views/schoolYear/index.vue")
        },

        // 学期
        {path: '/school/semester/index',
          name: 'SchoolSemesterIndex',
          component: () =>import("@/views/schoolSemester/index.vue")
        },

        // 资讯管理
        {
          path: '/article/index',
          name: 'ArticleIndex',
          component: () =>import("@/views/article/index.vue")
        },
        // 资讯创建
        {
          path: '/article/create',
          name: 'ArticleCreate',
          component: () =>import("@/views/article/create")
        },
        // 资讯编辑
        {
          path: '/article/edit',
          name: 'ArticleEdit',
          component: () =>import("@/views/article/edit")
        },
        // 课程分类管理
        {
          path: '/course/category/index',
          name: 'CourseCategoryIndex',
          component: () =>import("@/views/courseCategory/index.vue")
        },

        // 发票管理
        {
          path: '/course/order/index',
          name: 'InvoiceIndex',
          component: () =>import("@/views/studentOrder/invoice.vue")
        },

        // banner管理
        {
          path: '/banner/index',
          name: 'BannerIndex',
          component: () =>import("@/views/banner/index.vue")
        },
        {
          path: '/applet/index',
          name: 'AppletManageIndex',
          component: () =>import("@/views/applet/intro.vue")
        },
        // 小程序首页管理
        {
          path: '/applet/intro',
          name: 'AppletIntroIndex',
          component: () =>import("@/views/applet/intro.vue")
        },
        // 小程序关于我们管理
        {
          path: '/applet/about',
          name: 'AppletAboutIndex',
          component: () =>import("@/views/applet/about.vue")
        },

        // 退费审核
        {
          path: '/refund/apply/index',
          name: 'RefundApplyIndex',
          component: () =>import("@/views/refundApply/index.vue"),
          meta: {
            keepAlive: true
          }
        },
        {
          path: '/settle/index',
          name: 'SettleIndex',
          component: () =>import("@/views/settle/index")
        },
        {
          path: '/course/class/time/attendance',
          name: 'CourseClassTimeAttendance',
          component: () => import("@/views/courseClass/timeAttendance")
        },
        {
          path: '/course/class/attendance/teacher/detail',
          name: 'CourseClassAttendanceTeacherDetail',
          component: () => import("@/views/courseClass/attendanceTeacherDetail")
        },
        {
          path: '/teacher/course/fee',
          name: 'TeacherCourseFee',
          component: () => import("@/views/teacher/courseFee")
        },
        {
          path: '/dynamic/index',
          name: 'DynamicIndex',
          component: () => import("@/views/dynamic/index")
        },
        {
          path: '/student/parent/comment/index',
          name: 'StudentParentCommentIndex',
          component: () => import("@/views/studentParentComment/index")
        },
        {
          path: '/teacher/fee/index',
          name: 'TeacherFeeIndex',
          component: () => import("@/views/teacherFee/index")
        },
        {
          path: '/teacher/fee/detail',
          name: 'TeacherFeeDetail',
          component: () => import("@/views/teacherFee/detail")
        },
        {
          path: '/teacher/fee/check/index',
          name: 'TeacherFeeCheckIndex',
          component: () => import("@/views/teacherFeeCheck/index")
        },
        {
          path: '/teacher/fee/check/detail',
          name: 'TeacherFeeCheckDetail',
          component: () => import("@/views/teacherFeeCheck/detail")
        },
        {
          path: '/course/class/student',
          name: 'CourseClassStudent',
          component: () => import("@/views/courseClass/student")
        },
        {
          path: '/course/class/student/time/attendance',
          name: 'CourseClassStudentTimeAttendance',
          component: () => import("@/views/courseClass/studentTimeAttendance")
        },
        {
          path: '/course/class/student/index',
          name: 'CourseClassStudentIndex',
          component: () => import("@/views/courseClassStudent/index")
        },
        {
          path: '/course/class/teacher/attendance',
          name: 'CourseClassTeacherAttendance',
          component: () => import("@/views/courseClass/AttendanceTeacher")
        },
        {
          path: '/teacher/check',
          name: 'TeacherCheck',
          component: () => import("@/views/teacher/check")
        },
        {
          path: '/config/student/parent/menu',
          name: 'ConfigStudentParentMenu',
          component: () => import("@/views/config/studentParentMenu")
        },
        {
          path: '/config/teacher/menu',
          name: 'ConfigTeacherMenu',
          component: () => import("@/views/config/teacherMenu")
        },
        {
          path: '/course/edit',
          name: 'CourseEdit',
          component: () => import("@/views/course/edit")
        },
        {
          path: '/settle/school',
          name: 'SettleSchool',
          component: () => import("@/views/settle/school")
        },
        {
          path: '/draw/index',
          name: 'DrawIndex',
          component: () => import("@/views/draw/index")
        },
        {
          path: '/statistics/course',
          name: 'StatisticsCourse',
          component: () => import("@/views/statistics/course")
        },
        {
          path: '/statistics/attendance',
          name: 'StatisticsAttendance',
          component: () => import("@/views/statistics/attendance")
        },
        {
          path: '/statistics/teacher/attendance',
          name: 'StatisticsTeacherAttendance',
          component: () => import("@/views/statistics/teacherAttendance")
        },
        {
          path: '/statistics/course/class',
          name: 'StatisticsCourseClass',
          component: () => import("@/views/statistics/courseClass")
        },
        {
          path: '/draw/log',
          name: 'DrawLog',
          component: () => import("@/views/draw/log")
        },
        {
          path: '/draw/check',
          name: 'DrawCheck',
          component: () => import("@/views/draw/check")
        },
        {
          path: '/teacher/edit',
          name: 'TeacherEdit',
          component: () => import("@/views/teacher/edit")
        },
        {
          path: '/teacher/apply/edit',
          name: 'TeacherApplyEdit',
          component: () => import("@/views/teacherApply/edit")
        },
        {
          path: '/school/area/index',
          name: 'SchoolAreaIndex',
          component: () => import("@/views/schoolArea/index")
        },
        {
          path: '/agreement/add',
          name: 'AgreementAdd',
          component: () => import('@/views/applet/agreementAdd.vue'),
          meta: { title: '协议新增' }
        },
        {
          path: '/agreement/edit',
          name: 'AgreementEdit',
          component: () => import('@/views/applet/agreementEdit.vue'),
          meta: { title: '协议管理' }
        },
        {
          path: '/agreement/list',
          name: 'UserAgreements',
          component: () => import('@/views/applet/userAgreement.vue'),
          meta: { title: '协议编辑',  keepAlive: false }
        },
        {
          path: '/behavior/funnel/index',
          name: 'FunnelIndex',
          component: () => import('@/views/behavior/funnel/index.vue'),
          meta: { title: '漏斗列表', keepAlive: true }
        },
        {
          path: '/behavior/funnel/detail',
          name: 'FunnelDetail',
          component: () => import('@/views/behavior/funnel/detail.vue'),
          meta: { title: '漏斗详情' }
        },
        // 实时数据看板
        {
          path: '/behavior/realtime/dashboard',
          name: 'BehaviorRealtimeDashboard',
          component: () => import('@/views/behavior/realtime/dashboard.vue'),
          meta: { title: '实时数据看板' }
        },
        // 埋点配置列表
        {
          path: '/behavior/track/config',
          name: 'BehaviorTrackConfig',
          component: () => import('@/views/behavior/trackConfig/index.vue'),
          meta: { title: '埋点配置', keepAlive: true }
        },
        // 埋点配置表单
        {
          path: '/behavior/track/config/form',
          name: 'BehaviorTrackConfigForm',
          component: () => import('@/views/behavior/trackConfig/form.vue'),
          meta: { title: '埋点配置表单' }
        },
        // 告警规则列表
        {
          path: '/behavior/alert/rule',
          name: 'BehaviorAlertRule',
          component: () => import('@/views/behavior/alertRule/index.vue'),
          meta: { title: '告警规则', keepAlive: true }
        },
        // 告警规则表单
        {
          path: '/behavior/alert/rule/form',
          name: 'BehaviorAlertRuleForm',
          component: () => import('@/views/behavior/alertRule/form.vue'),
          meta: { title: '告警规则表单' }
        },
        // 告警历史
        {
          path: '/behavior/alert/history',
          name: 'BehaviorAlertHistory',
          component: () => import('@/views/behavior/alertHistory/index.vue'),
          meta: { title: '告警历史', keepAlive: true }
        },
        // 数据导出
        {
          path: '/behavior/export',
          name: 'BehaviorExport',
          component: () => import('@/views/behavior/export/index.vue'),
          meta: { title: '数据导出' }
        },
        // 留存分析
        {
          path: '/behavior/retention',
          name: 'BehaviorRetention',
          component: () => import('@/views/behavior/retention/index.vue'),
          meta: { title: '留存分析' }
        },
        // 用户画像查询
        {
          path: '/behavior/user/profile',
          name: 'BehaviorUserProfile',
          component: () => import('@/views/behavior/userProfile/index.vue'),
          meta: { title: '用户画像' }
        },
        // 用户画像详情
        {
          path: '/behavior/user/profile/detail',
          name: 'BehaviorUserProfileDetail',
          component: () => import('@/views/behavior/userProfile/detail.vue'),
          meta: { title: '用户画像详情' }
        },
        // 用户分群列表
        {
          path: '/behavior/user/segment',
          name: 'BehaviorUserSegment',
          component: () => import('@/views/behavior/userSegment/index.vue'),
          meta: { title: '用户分群', keepAlive: true }
        },
        // 用户分群表单
        {
          path: '/behavior/user/segment/form',
          name: 'BehaviorUserSegmentForm',
          component: () => import('@/views/behavior/userSegment/form.vue'),
          meta: { title: '用户分群表单' }
        },
        // 收费项目管理
        {
          path: '/fee/index',
          name: 'FeeIndex',
          component: () => import("@/views/fee/index"),
          meta: { keepAlive: true }
        },
        {
          path: '/fee/create',
          name: 'FeeCreate',
          component: () => import("@/views/fee/create")
        },
        {
          path: '/fee/edit',
          name: 'FeeEdit',
          component: () => import("@/views/fee/edit")
        },
        {
          path: '/fee/detail',
          name: 'FeeDetail',
          component: () => import("@/views/fee/detail")
        },
        // 订单管理（Epic 2）
        {
          path: '/fee/order/list',
          name: 'FeeOrderList',
          component: () => import("@/views/fee/order/index"),
          meta: { keepAlive: true }
        },
        {
          path: '/fee/order/index',
          name: 'FeeOrderIndex',
          component: () => import("@/views/fee/order/index"),
          meta: { keepAlive: true }
        },
        {
          path: '/fee/order/detail',
          name: 'FeeOrderDetail',
          component: () => import("@/views/fee/order/detail")
        },
        // 退费管理（Epic 3）
        {
          path: '/fee/refund',
          name: 'FeeRefundIndex',
          component: () => import("@/views/fee/refund/index"),
          meta: { keepAlive: true }
        },
        // 退费审核
        {
          path: '/fee/refund/audit',
          name: 'FeeRefundAuditIndex',
          component: () => import("@/views/fee/refund/audit")
        },
        // 班级考勤看板
        {
          path: '/attendance/classBoard',
          name: 'AttendanceBoard',
          component: () => import('@/views/attendance/classBoard')
        },
        // 课次点名（看板「去点名」下钻）
        {
          path: '/attendance/classRollCall',
          name: 'AttendanceClassRollCall',
          component: () => import('@/views/attendance/rollCall'),
          meta: { title: '课次点名' }
        },
        // 补课管理台账（独立二级页；菜单 front_router = MakeupManage）
        // 补课跨班 ⇒ 以班级为主键的看板拼不出全校台账，必须是独立页
        {
          path: '/attendance/makeup',
          name: 'MakeupManage',
          component: () => import('@/views/attendance/makeupBoard'),
          meta: { title: '补课管理' }
        }
		//{~routers~}
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js